import { Component, Input } from '@angular/core';
import { CMSLanguageService } from '@markant-platform/shared/data-access';
import { map, Observable, startWith, switchMap, tap } from 'rxjs';
import { CmsLink, InternalCmsLink } from '@markant-platform/shared/content/model';
import { ContentService } from '@markant-platform/shared/content/data-access';
import { MarkantElementsModule } from '@markant/elements-angular';
import { AsyncPipe, NgForOf, NgIf } from '@angular/common';
import { RouterLink } from '@angular/router';

@Component({
  standalone: true,
  selector: 'markant-platform-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  imports: [MarkantElementsModule, AsyncPipe, RouterLink, NgForOf, NgIf],
})
export class FooterComponent {
  footerLinks: Observable<InternalCmsLink[]>;

  defaultPublicLinks: CmsLink[] = [
    {
      href: '/legal-notice',
      target: '_self',
      text: 'Legal notice',
      externalLink: false,
    },
    {
      href: '/privacy-notice',
      target: '_self',
      text: 'Privacy notice',
      externalLink: false,
    },
    {
      href: '/privacy-notice?showpc=true',
      target: '_self',
      text: 'Cookie settings',
      externalLink: false,
    },
  ];
  defaultPrivateLinks: CmsLink[] = [
    {
      href: '/legal-notice',
      target: '_self',
      text: 'Legal notice',
      externalLink: false,
    },
    {
      href: '/privacy-notice',
      target: '_self',
      text: 'Privacy notice',
      externalLink: false,
    },
    {
      href: '/termsofuse',
      target: '_self',
      text: 'Terms of Use',
      externalLink: false,
    },
    {
      href: 'OneTrust.ToggleInfoDisplay()',
      target: '_self',
      text: 'Cookie settings',
      externalLink: false,
    },
  ];

  @Input() isPublic = false;
  isDefault = true;

  constructor(
    private readonly cmsLanguageService: CMSLanguageService,
    private readonly contentService: ContentService
  ) {
    this.footerLinks = this.cmsLanguageService.activeCMSLanguage$.pipe(
      switchMap(() => {
        return contentService.getFooterLinks(this.isPublic).pipe(
          map(links =>
            this.isPublic
              ? (links as InternalCmsLink[])
              : links
                  .map(this.contentService.mapCmsLinkToInternalLink)
                  .filter(link => link.isCookieButton || link.pageId)
          ),
          tap(_ => (this.isDefault = false)),
          startWith(
            this.isPublic
              ? (this.defaultPublicLinks as InternalCmsLink[])
              : this.defaultPrivateLinks.map(this.contentService.mapCmsLinkToInternalLink)
          )
        );
      })
    );
  }

  toggleCookieSettings(): void {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore -- ignore not existing function because it is set by an external script
    OneTrust.ToggleInfoDisplay();
  }
}
